import React, { useMemo } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField
} from "@mui/material";
import { sdmTableStyles, getHeaderCellStyle } from "./sdmTableStyles";

const LimitDynamicsTable = ({ data, onChange }) => {
  const limitData = data || {
    dates: ["", "", "", "", ""],
    workingCapitalLoans: [0, 0, 0, 0, 0],
    investmentLoans: [0, 0, 0, 0, 0],
    shortTermWorkingCapitalLoans: [0, 0, 0, 0, 0],
    transactionLoans: [0, 0, 0, 0, 0],
    thereofCashCoverLimit: [0, 0, 0, 0, 0],
    overdrafts: [0, 0, 0, 0, 0],
    leasing: [0, 0, 0, 0, 0],
    factoring: [0, 0, 0, 0, 0],
    guarantees: [0, 0, 0, 0, 0],
    expressGuarantees: [0, 0, 0, 0, 0]
  };

  const rows = [
    { label: "кредиты оборотные", field: "workingCapitalLoans" },
    { label: "инвестиционный кредит", field: "investmentLoans" },
    { label: "краткосрочные оборотные кредиты", field: "shortTermWorkingCapitalLoans" },
    { label: "сделочные кредиты", field: "transactionLoans" },
    { label: "овердрафты", field: "overdrafts" },
    { label: "лизинг", field: "leasing" },
    { label: "факторинг", field: "factoring" },
    { label: "гарантии", field: "guarantees" },
    { label: "экспресс гарантии", field: "expressGuarantees" }
  ];

  const totals = useMemo(() => {
    const sums = [0, 0, 0, 0, 0];
    const excludedFields = [];
    rows.forEach(row => {
      if (!excludedFields.includes(row.field)) {
        const values = limitData[row.field] || [0, 0, 0, 0, 0];
        values.forEach((val, idx) => {
          sums[idx] += Number(val) || 0;
        });
      }
    });
    return sums;
  }, [limitData]);

  const handleCellChange = (field, columnIndex, value) => {
    const updatedData = { ...limitData };
    if (!updatedData[field]) {
      updatedData[field] = [0, 0, 0, 0, 0];
    }
    updatedData[field] = [...updatedData[field]];
    updatedData[field][columnIndex] = value === "" ? 0 : Number(value);
    onChange(updatedData);
  };

  const getColumnValue = (field, columnIndex) => {
    const values = limitData[field] || [0, 0, 0, 0, 0];
    return values[columnIndex] || 0;
  };

  const handleDateChange = (columnIndex, value) => {
    const newDates = [...(limitData.dates || ["", "", "", "", ""])];
    newDates[columnIndex] = value;
    onChange({
      ...limitData,
      dates: newDates
    });
  };

  const getDateValueForPicker = (colIdx) => {
    const dateStr = limitData.dates && limitData.dates[colIdx];
    if (!dateStr) return "";
    return dateStr.split("T")[0];
  };

  const columns = [
    { label: "", minWidth: 250 },
    { label: "", minWidth: 100, align: "right" },
    { label: "", minWidth: 100, align: "right" },
    { label: "", minWidth: 100, align: "right" },
    { label: "", minWidth: 100, align: "right" },
    { label: "", minWidth: 100, align: "right" },
  ];

  return (
    <Box sx={sdmTableStyles.tableWrapper}>
      <Box sx={sdmTableStyles.headerSection}>
        <Box sx={sdmTableStyles.sectionTitle}>
          Динамика лимитов
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={sdmTableStyles.tableContainer}
      >
        <Table size={sdmTableStyles.tableSize}>
          <TableHead>
<TableRow sx={sdmTableStyles.headerRow}>
              <TableCell sx={getHeaderCellStyle(250)}>
              </TableCell>
              {[0, 1, 2, 3, 4].map((colIdx) => (
                <TableCell key={colIdx} align="right" sx={getHeaderCellStyle(100)}>
                  <TextField
                    type="date"
                    value={getDateValueForPicker(colIdx)}
                    onChange={(e) => handleDateChange(colIdx, e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow sx={sdmTableStyles.highlightedRow}>
              <TableCell sx={{ ...sdmTableStyles.dataCell, fontWeight: 600, fontSize: "13px", color: "#111827" }}>
                Кредитн.продукты
              </TableCell>
              {totals.map((total, idx) => (
                <TableCell key={idx} align="right" sx={{ ...sdmTableStyles.dataCell, fontWeight: 600, fontSize: "13px", color: "#111827" }}>
                  {total.toFixed(2)}
                </TableCell>
              ))}
            </TableRow>

            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} sx={sdmTableStyles.dataRow}>
                <TableCell sx={{ ...sdmTableStyles.dataCell, fontSize: "13px", color: "#111827" }}>
                  {row.label}
                </TableCell>
                {[0, 1, 2, 3, 4].map((colIdx) => (
                  <TableCell key={colIdx} align="right" sx={sdmTableStyles.dataCell}>
                    <TextField
                      type="number"
                      value={getColumnValue(row.field, colIdx)}
                      onChange={(e) => handleCellChange(row.field, colIdx, e.target.value)}
                      onWheel={(e) => e.target.blur()}
                      variant="outlined"
                      size="small"
                      fullWidth
                      inputProps={{
                        step: "0.01",
                        style: { textAlign: "right" }
                      }}
                      sx={sdmTableStyles.numberField}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LimitDynamicsTable;
